<template lang="pug">
  div.survey
    iframe(src="https://docs.google.com/forms/d/e/1FAIpQLSeYkstymUzK4yTKFJRL456JWo8whvnD_DEOlKNTuwQ8EULNiw/viewform?embedded=true" width="640" height="1741" frameborder="0" marginheight="0" marginwidth="0") Loading...
</template>

<script>

export default {
  name: 'Survey',
  components: {
  },
  data () {
    return {
    }
  }
}
</script>


<style lang="stylus" scoped>
.survey
  margin 0 auto
  text-align center
</style>